import { Props_SnippetContent } from './Content.props'
import React from 'react'

export const SnippetContent = (props: Props_SnippetContent) => {

    const headingVisible = props.heading?.visibility?.value !== 'hidden';
    const headingClassName = `snippet-content__heading${!headingVisible ? ' snippet-content__heading--hidden' : ''}`;

    return (
    <section className='snippet-content'>
        <div className="snippet-content__container">
            {props.heading?.level?.value && React.createElement(props.heading.level.value, { className: headingClassName }, props.heading?.heading?.value) }
            <div className="snippet-content__content">
            {props.repeatable_paragraph?.map((paragraph, index) => (
                <p key={index} className="snippet-content__paragraph">{paragraph.text?.value}</p>
            ))}
            </div>
            <div className="snippet-content__links">
            {props.repeatable_link?.map((link, index) => (
                <a key={index} className="snippet-content__link" href={link.linkhref?.value}>{link.linktext?.value}</a>
            ))}
            </div>
        </div>
    </section>
    )
}
